import { Skeleton, Card, Button } from "antd";
import { useNavigate } from "react-router-dom";

const SubscriptionSkeleton = () => {
  const navigate = useNavigate();
  return (
    <Card className="w-full max-w-md p-6 mx-auto shadow-lg">
      {/* Título */}
      <Skeleton.Input active size="large" className="w-2/3 mx-auto mb-4" />

      {/* Información de suscripción */}
      <div className="flex items-center mb-4 space-x-4">
        <Skeleton.Avatar active size="large" />
        <div>
          <Skeleton.Input active size="small" className="w-40 mb-2" />
          <Skeleton.Input active size="small" className="w-28" />
        </div>
      </div>

      {/* Costo Mensual */}
      <Skeleton.Button active size="large" block className="mb-4" />

      {/* Métodos de pago */}
      <div className="flex justify-between mb-4">
        <Skeleton.Button active size="large" className="w-1/2 mr-2" />
        <Skeleton.Button active size="large" className="w-1/2 ml-2" />
      </div>

      {/* Descripción */}
      <Skeleton paragraph={{ rows: 2 }} active />

      {/* Botón de cancelar */}
      <Button block  className="mt-4" onClick={() => navigate(-1)}>
        Cancelar
      </Button>
    </Card>
  );
};

export default SubscriptionSkeleton;
